import React from 'react';
import { IconProps } from './props';

export const LaughIcon = (props: IconProps) => (
	<svg
		width="25"
		height="24"
		viewBox="0 0 25 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M21.5 12C21.5 7.02944 17.4706 3 12.5 3C7.52944 3 3.5 7.02944 3.5 12C3.5 16.9706 7.52944 21 12.5 21C17.4706 21 21.5 16.9706 21.5 12ZM23.5 12C23.5 18.0751 18.5751 23 12.5 23C6.42487 23 1.5 18.0751 1.5 12C1.5 5.92487 6.42487 1 12.5 1C18.5751 1 23.5 5.92487 23.5 12Z"
			fill={props.fillColor ?? 'black'}
		/>
		<path
			d="M18.4998 12C18.7941 12 19.0735 12.1297 19.2635 12.3545C19.4535 12.5793 19.5351 12.8768 19.4861 13.167C19.2077 14.8146 18.3488 16.3082 17.0652 17.3779C15.7882 18.4421 14.1741 19.0159 12.5125 18.999L12.5135 19C12.5089 19.0001 12.5043 18.999 12.4998 18.999C12.4952 18.999 12.4907 19.0001 12.4861 19V18.999C10.8248 19.0157 9.21111 18.4419 7.93435 17.3779C6.65077 16.3082 5.79187 14.8146 5.51346 13.167C5.46443 12.8768 5.54611 12.5793 5.73611 12.3545C5.92612 12.1297 6.20545 12 6.49978 12H18.4998ZM7.83474 14C8.14363 14.7077 8.61297 15.3404 9.21463 15.8418C10.1317 16.606 11.2925 17.0167 12.4861 17C12.4952 16.9999 12.5043 16.9999 12.5135 17L12.7371 16.998C13.8514 16.9638 14.9252 16.5582 15.7849 15.8418C16.3866 15.3404 16.8559 14.7077 17.1648 14H7.83474Z"
			fill={props.fillColor ?? 'black'}
		/>
		<path
			d="M9.50977 8L9.6123 8.00488C10.1165 8.05611 10.5098 8.48224 10.5098 9C10.5098 9.51776 10.1165 9.94389 9.6123 9.99512L9.50977 10H9.5C8.94772 10 8.5 9.55228 8.5 9C8.5 8.44772 8.94772 8 9.5 8H9.50977Z"
			fill={props.fillColor ?? 'black'}
		/>
		<path
			d="M15.5098 8L15.6123 8.00488C16.1165 8.05611 16.5098 8.48224 16.5098 9C16.5098 9.51776 16.1165 9.94389 15.6123 9.99512L15.5098 10H15.5C14.9477 10 14.5 9.55228 14.5 9C14.5 8.44772 14.9477 8 15.5 8H15.5098Z"
			fill={props.fillColor ?? 'black'}
		/>
	</svg>
);
